import { createContext } from 'react'

import { type UseSnippetCarouselReturn } from './use-snippet-carousel'

export type SnippetCarouselContext = UseSnippetCarouselReturn

export const SnippetCarouselContext = createContext<SnippetCarouselContext>(
  {} as SnippetCarouselContext
)
